import { createSlice } from "@reduxjs/toolkit";

import {} from "../actions"
import {
  verifyOtpCognito,
  activateTenantAccount,
  sendNewOtp
} from "./actions"

const initialState = {
  loading: false,
  otpChecked: false,
  reSendButtonLoading: false,
  verifyButtonLoading: false,
  passwordButtonLoading: false,
  activationDone: false,
  messagge: ""
};

const activateAccounSlice = createSlice({
  name: "activateAccount",
  initialState: initialState,
  reducers: {
    reseActivate: (state) => { state.downloadUrl = "" },
  },
  extraReducers: (builder) => {
    builder.addCase(verifyOtpCognito.pending, (state) => {
      state.loading = true;
      state.verifyButtonLoading = true;
    });
    builder.addCase(verifyOtpCognito.fulfilled, (state, action)=>{
      state.loading = false;
      state.verifyButtonLoading = false;
      state.otpChecked = action.payload.success ? true:false;
    });
    builder.addCase(verifyOtpCognito.rejected, (state) => {
      state.loading = false;
      state.verifyButtonLoading = false;
    });

    builder.addCase(activateTenantAccount.pending, (state) => {
      state.loading = true;
      state.passwordButtonLoading = true;
    });
    builder.addCase(activateTenantAccount.fulfilled, (state, action) => {
      state.loading = false;
      state.passwordButtonLoading = false;
      state.otpChecked = action.payload.success ? true : false;
      state.activationDone = action.payload.success ? true : false;
    });
    builder.addCase(activateTenantAccount.rejected, (state) => {
      state.loading = false;
      state.passwordButtonLoading = false;
    });

    builder.addCase(sendNewOtp.pending, (state) => {
      state.reSendButtonLoading = true;
    });
    builder.addCase(sendNewOtp.fulfilled, (state) => {
      state.loading = false;
      state.reSendButtonLoading = false;
    });
    builder.addCase(sendNewOtp.rejected, (state) => {
      state.loading = false;
      state.reSendButtonLoading = false;
    });
  }
})

export const { reseActivate } = activateAccounSlice.actions;
export default activateAccounSlice.reducer;